import React from 'react';
import { Drawer, Grid } from 'antd';
import type { DrawerProps } from 'antd';
import { layoutTokens, type DrawerSize } from '../layout/layoutTokens';

export interface ResponsiveDrawerProps extends Omit<DrawerProps, 'width' | 'size'> {
  /** 档位宽度：sm/md/lg；窄屏（< md）自动全宽 */
  size?: DrawerSize;
}

/**
 * 右侧详情侧滑：桌面用固定档位宽度，&lt; md 时全宽（移动端兜底）。
 */
const ResponsiveDrawer: React.FC<ResponsiveDrawerProps> = ({
  size = 'md',
  placement = 'right',
  destroyOnClose = true,
  children,
  ...rest
}) => {
  const screens = Grid.useBreakpoint();
  const isNarrow = screens.md === false;
  const width = isNarrow ? '100%' : layoutTokens.drawer[size];

  return (
    <Drawer placement={placement} width={width} destroyOnClose={destroyOnClose} {...rest}>
      {children}
    </Drawer>
  );
};

export default ResponsiveDrawer;
